import { render } from "./PAMMMoneyManagerList.vue?vue&type=template&id=b2bc1dfa"
import script from "./PAMMMoneyManagerList.vue?vue&type=script&lang=js"
export * from "./PAMMMoneyManagerList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_d1e78fc5a76ea737c4af49906cc931c6/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__